// Heading and paragraph blocks

// Handle drop shadow color for heading and paragraph blocks
document.addEventListener('DOMContentLoaded', () => {
	// Select all elements with is-style-drop-shadow class (including those missing wp-block-* class)
	document.querySelectorAll('.is-style-drop-shadow').forEach((element) => {
		// Check if element has the style attribute with --drop-shadow-color
		const styleAttr = element.getAttribute('style');
		if (styleAttr && styleAttr.includes('--drop-shadow-color')) {
			// Style is already in the attribute, CSS should pick it up
			// But ensure it's applied correctly
			const match = styleAttr.match(/--drop-shadow-color:\s*([^;]+)/);
			if (match) {
				element.style.setProperty('--drop-shadow-color', match[1].trim());
			}
		} else {
			// Check for data attribute as fallback
			const shadowColor = element.getAttribute('data-drop-shadow-color');
			if (shadowColor) {
				element.style.setProperty('--drop-shadow-color', shadowColor);
			}
		}
	});
});

